// extracted by mini-css-extract-plugin
module.exports = {"create":"Add-module__create___1xDq5","list":"Add-module__list___gYPSG Fonts-module__at___1f_7n","new":"Add-module__new___2pPCT"};